var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('action-button',{attrs:{"type":_vm.type,"variant":_vm.variant,"enabled":_vm.delayedEnabled,"running":_vm.delayedRunning,"idleLabel":_vm.idleLabel,"runningLabel":_vm.runningLabel},on:{"click":_vm.clickHandler}})}
var staticRenderFns = []

export { render, staticRenderFns }